import { useEffect, useState } from "react";
import { toast } from "sonner";
import { installState, onInstallChange, promptInstall } from "@/lib/install";

export default function InstallButton({ compact = false }) {
  const [state, setState] = useState(installState());
  useEffect(() => onInstallChange(setState), []);

  if (state === "installed" || state === "unavailable") return null;

  const onClick = async () => {
    if (state === "ios") {
      toast("On iPhone: tap Share, then “Add to Home Screen”", { duration: 6000 });
      return;
    }
    const outcome = await promptInstall();
    if (outcome === "accepted") toast.success("Aetheria is on your home screen");
  };

  return (
    <button
      data-testid="install-button"
      onClick={onClick}
      className={
        compact
          ? "flex items-center gap-2 rounded-full border border-[#D4AF37]/50 bg-[#12141C]/90 px-4 py-3 font-mono text-[10px] tracking-[0.25em] text-[#D4AF37] shadow-lg shadow-black/40 backdrop-blur transition-colors hover:bg-[#D4AF37] hover:text-[#0B0C10]"
          : "inline-flex items-center gap-3 border border-[#D4AF37]/50 px-5 py-3 font-mono text-[9px] tracking-[0.3em] text-[#D4AF37] transition-all duration-300 hover:bg-[#D4AF37] hover:text-[#0B0C10]"
      }
    >
      <span aria-hidden>⤓</span>
      {compact ? "INSTALL" : "INSTALL THE ATLAS — OPENS FULL-SCREEN"}
    </button>
  );
}
